import { Prop, Watch } from 'vue-property-decorator';
import Component, { mixins } from 'vue-class-component';
import { Solicitud } from '@/shared/model/solicitud.model';
import SolucionMixin from '@/entities/evaluacion/mixins/solucion-mixin';
import { IFiltro } from '@/shared/model/filtro.model';
import { FiltroRevision } from '@/shared/model/filtro-revision.model';
import { EstadoRevision } from '@/shared/model/enumerations/estado-revision.model';
import { IRevision } from '@/shared/model/revision.model';
import RevisionMixin from '@/entities/evaluacion/mixins/revision-mixin';
import SolicitudMixin from '@/entities/evaluacion/mixins/solicitud-mixin';
import { Solucion } from '@/shared/model/solucion.model';

@Component
export default class ResultadoBecasComponent extends mixins(SolucionMixin, RevisionMixin, SolicitudMixin) {
  @Prop({ required: true })
  public solicitud: Solicitud;

  @Prop({ required: true })
  public solucionResultado: Solucion;

  public revisionRecons: Array<IRevision> = [];

  public readonly numeroRevisones: number = 3;

  mounted(): void {
    if (this.solicitud && this.solucionResultado) {
      this.revisionRecons = null;
      if (this.verResultado) {
        this.getRevisionBecas();
      }
    }
  }

  /**
   * Por medio del filtro paginationQuery hace la
   * petición/consulta a revision-mixxin para obtener
   * la revisión de becas extranjeras  y estatus REVISADA.
   *
   */
  private getRevisionBecas(): void {
    const filtroSol: IFiltro = {};
    const filtroRev: FiltroRevision = {};

    filtroRev.solucionId = this.solicitud.solucionId;
    filtroRev.estado = EstadoRevision.REVISADA;
    filtroSol.solucionId = this.solicitud.solucionId;
    filtroSol.solicitudId = this.solicitud.id;
    filtroSol.cvuSolicitante = this.solicitud.solicitante.cvu;

    const filtroSolRev = Object.assign(filtroRev, filtroSol);

    const paginationQuery = {
      page: 0,
      size: 1,
      sort: this.sort(),
      filter: filtroSolRev,
    };

    this.getRevisiones(paginationQuery);
  }

  /**
   * Busca la revisiones que cuenta la solicitud,
   * valida que sean las tres revisiones que se realizan y la muestra hacia el Front.
   */
  @Watch('solicitudRevisiones')
  public getRevisionFinal(): void {
    for (const solicitudRevision of this.solicitudRevisiones) {
      if (solicitudRevision.revisiones.length === this.numeroRevisones) {
        this.revisionRecons = solicitudRevision.revisiones;
      }
    }
  }

  /**
   * Valida que el cvu este en la lista
   * para visualizar los resultados.
   */
  public get verResultado(): boolean {
    return this.solucionResultado?.params?.cvusEvaluacionINAI.some((cvu: string) => cvu === this.solicitud.solicitante.cvu);
  }
}
